import barba from "@barba/core";
import { gsap } from "gsap";
import Alpine from "alpinejs";

const layer = document.querySelector(".c-loader__layer");
const spinner = document.querySelector(".c-loader__spinner-wrap");

Alpine.data("pageLoader", () => ({
  init() {
    this.enter();

    barba.hooks.leave(this.leave.bind(this));
    barba.hooks.enter(this.enter.bind(this));
  },
  enter() {
    gsap.fromTo(
      spinner,
      {
        opacity: 1,
        scale: 1,
      },
      { opacity: 0, scale: 0.5 },
    );
    
    gsap.fromTo(
      layer,
      { y: "0%" },
      {
        y: "-100%",
        onComplete: () => {
          this.$root.classList.add("hidden");
        },
      },
    );
  },
  leave() {
    this.$root.classList.remove("hidden");

    return new Promise((resolve) => {
      gsap.fromTo(
        spinner,
        { opacity: 0, scale: 0.5 },
        {
          opacity: 1,
          scale: 1,
        },
      );
      gsap.fromTo(
        layer,
        { y: "100%" },
        {
          y: "0%",
          onComplete: () => {
            resolve(true);
          },
        },
      );
    });
  },
}));
